import { Navigate } from "react-router-dom";
import { AccessBehaviorProps } from "../AccessGate.types";

export type RedirectBehaviorConfig = {
    to?: string;
    replace?: boolean;
};

export function RedirectBehavior({ config }: AccessBehaviorProps) {
    const { to = "/", replace = true } = (config ?? {}) as RedirectBehaviorConfig;

    // Route-level blocked states should leave the protected page entirely.
    return <Navigate to={to} replace={replace} />;
}
